/* istanbul ignore next */
export default ((typeof window !== 'undefined' ? window : global) || {}) as any
